import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFleet2Outlined = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.7208 10.9L16.9013 37.1H30.6846L28.8651 10.9H18.7208ZM15.8859 9.86144C15.9587 8.81317 16.8303 8 17.8811 8H29.7048C30.7556 8 31.6272 8.81317 31.7 9.86144L33.6444 37.8614C33.7247 39.0178 32.8084 40 31.6492 40H15.9367C14.7775 40 13.8612 39.0178 13.9415 37.8614L15.8859 9.86144ZM9.66429 14C10.8511 14 11.7768 15.0274 11.6535 16.2078L9.56419 36.2078C9.45779 37.2264 8.59914 38 7.57502 38H7.00019C5.81792 38 4.89367 36.98 5.00987 35.8034L6.98518 15.8034C7.08626 14.78 7.94706 14 8.9755 14H9.66429ZM38.0217 36.2078C38.1281 37.2264 38.9867 38 40.0108 38H40.5857C41.7679 38 42.6922 36.98 42.576 35.8034L40.6007 15.8034C40.4996 14.78 39.6388 14 38.6104 14H37.9216C36.7348 14 35.8091 15.0274 35.9324 16.2078L38.0217 36.2078Z",
		fill: "black"
	})
});
export default SvgFleet2Outlined;
